import { useEffect } from "react";
/**
 * Attach a `beforeunload` listener while the buyer has started the checkout
 * but hasn't completed it — so a stray tab-close or back-navigation pops the
 * browser's native "Leave site?" confirmation instead of silently discarding
 * the in-progress purchase.
 *
 * Browsers ignore any custom text returned from a `beforeunload` handler and
 * render their own generic prompt (policy change after 2016), so this hook
 * only toggles the trigger — there is no way to show a branded message at
 * unload time. Custom confirm modals can't block unload either because the
 * close action is synchronous, which makes the native prompt the only
 * mechanism that actually intercepts it.
 */ function useAbandonGuard(active) {
    useEffect(()=>{
        if (!active) {
            return undefined;
        }
        const handler = (event)=>{
            event.preventDefault();
            // Chrome still requires `returnValue` even though `preventDefault()`
            // is the spec-compliant path; the string content is ignored.
            event.returnValue = "";
        };
        window.addEventListener("beforeunload", handler);
        return ()=>{
            window.removeEventListener("beforeunload", handler);
        };
    }, [
        active
    ]);
}
export { useAbandonGuard };
